import { AppMobileHeaderLevel3Component, MobileHeaderLevel3TypeAccessor } from '$components';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, filter, map } from 'rxjs';
import { Models } from '../../../../shared/models';
import { VipLevel } from '../../../../shared/models/assets.model';
import { ApiService } from '../../../../shared/stores/api';
import { ProgramBadgeComponent, Statistics } from '../../components/program-badge/program-badge.component';
import { ThemeData, VipLevelBannerService } from '../../shared/services/vip-level-banner.service';

@Component({
  selector: 'app-program-badge-wrapper',
  templateUrl: './program-badge-wrapper.component.html',
  styleUrls: ['./program-badge-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [AppMobileHeaderLevel3Component, ProgramBadgeComponent, AsyncPipe],
})
export class ProgramBadgeWrapperComponent implements MobileHeaderLevel3TypeAccessor {
  private readonly api = inject(ApiService);
  private readonly vipLevelBannerService = inject(VipLevelBannerService);
  private readonly router = inject(Router);

  readonly headerTitle = 'Account Details';
  readonly closeButtonAction = () => {
    this.router.navigate(['/', 'my-profile', 'account-details']);
  };

  public readonly VipLevel = VipLevel;
  private vipLevelState: Observable<Models.GetVipLevelsResponse> = this.api.viplevels.select$.pipe(
    filter(state => !!state),
  ) as Observable<Models.GetVipLevelsResponse>;

  public vipLevelStatistics$: Observable<Statistics> = this.vipLevelState.pipe(
    filter(state => state.VIPLEVEL !== this.VipLevel.NOLEVEL),
    map(state => {
      return {
        numberPropertiesPurchased: state.NUMBERPROPERTIESPURCHASED,
        averagePurchasePrice: state.AVERAGEPURCHASEPRICE,
        numberPropsBidOn: state.NUMBERPROPSBIDON,
        percentOfValue: state.PERCENTOFVALUE,
      };
    }),
  );

  public badgeThemeData: Observable<ThemeData> = this.vipLevelState.pipe(
    filter(state => state.VIPLEVEL !== this.VipLevel.NOLEVEL),
    map(state => {
      const uiData = this.vipLevelBannerService.getVipLevelUiData(state.VIPLEVEL);
      uiData.vipStateText = this.replacePlaceholderWithNumberOfPropertiesLeft(uiData.vipStateText, state.PROPERTIESTONEXTLEVEL);
      return uiData;
    }),
  );

  public vipLevel: Observable<VipLevel> = this.vipLevelState.pipe(map(state => state.VIPLEVEL));

  private replacePlaceholderWithNumberOfPropertiesLeft(vipStateText: string, propertiesToNextLevel: number): string {
    return vipStateText.replace(/\{O\}/g, propertiesToNextLevel.toString());
  }
}
